import { Injectable, NgZone } from "@angular/core";
import { BehaviorSubject, firstValueFrom } from "rxjs"; // Import firstValueFrom
import { Messaging, getToken, onMessage } from "@angular/fire/messaging";
import { environment } from "../../environments/environment";
import { ApiModulesService } from "./api-modules.service";

@Injectable({
  providedIn: "root",
})
export class MessagingService {
  currentMessage = new BehaviorSubject<any>(null);

  constructor(
    private messaging: Messaging,
    private apiService: ApiModulesService,
    private zone: NgZone
  ) {}

  // Refactor to use async/await for cleaner handling
  async requestPermission(): Promise<void> {
    await this.zone.run(async () => {
      try {
        const token = await getToken(this.messaging, {
          vapidKey: environment.firebaseConfig.vapidKey,
        });

        if (token) {
          // Use firstValueFrom to await the observable from the API call
          await firstValueFrom(
            this.apiService.add({ fcm_token: token }, "fcm_token_update")
          );
        } else {
          console.warn("No registration token available. User might have denied permission.");
        }
      } catch (err) {
        console.error("An error occurred while retrieving token. ", err);
      }
    });
  }

  receiveMessage() {
    onMessage(this.messaging, (payload) => {
      this.zone.run(() => {
        const title = payload?.notification?.title || "New Notification";
        const body = payload?.notification?.body || "You have a new message";

        const baseUrl = payload?.data?.app_url || '';
        const userType = payload?.data?.user_type || '';
        const menuLink = payload?.data?.menu_link || '';

        const clickUrl = [baseUrl.replace(/\/$/, ''), userType, menuLink]
          .filter(part => part) // Remove any empty parts
          .join('/');
        const notification = new Notification(title, {
          body: body,
          icon: "/assets/notification-icon.png",
          data: { url: clickUrl },
        });

        notification.onclick = function (event) {
          event.preventDefault();
          const openWindow = window.open(notification.data.url, "_blank");
          if (openWindow) {
            openWindow.focus();
          }
        };
        this.currentMessage.next(payload); // Broadcast message to subscribers
      });
    });
  }

}
